//#region IMPORTS
import LoginContainerVersionOne from "../../components/accounts/LoginContainerVersionOne";
import "./Account.css";
//#endregion

export default function LoginPage() {
  //#region RENDER
  return (
    <LoginContainerVersionOne />
  );
  //#endregion
}
